import React from "react";
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import FormikSelect from "components/formikSelect";
import FormikInput from "components/formikInput";

const EditModal = ({ isOpen, onClose, size = "xl" }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent maxWidth={"800px"} borderRadius={"16px"} p={4}>
        <ModalBody gap={6} display={"flex"} flexDirection={"column"}>
          <Text
            fontSize={"24px"}
            fontFamily={"PlusJakartaSansSemiBold"}
            color={"#000000"}
          >
            Edit Product
          </Text>
          <Divider borderWidth={"1px"} width={"100%"} color={"#8A8F9333"} />
          <Box>
            <Text
              fontWeight={"600"}
              fontSize={"16px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              color={"#000000"}
              pb={4}
            >
              General Details
            </Text>
            <Box
              height={"276px"}
              borderRadius={"6px"}
              padding={"16px"}
              border={"1px solid #D9D9D9"}
            >
              <Flex gap={5}>
                <FormikInput label={"SKU"} placeholder={"Select one.."} />
                <FormikInput
                  label={"Product Title"}
                  placeholder={"Select one.."}
                />
              </Flex>
              <Flex gap={5} pt={"10px"}>
                <FormikSelect label={"Location"} placeholder={"Select one.."} />
                <FormikSelect
                  label={"Website Link"}
                  placeholder={"Select one.."}
                />
              </Flex>
              <Flex gap={5} pt={"10px"} mb={"10px"}>
                <FormikSelect label={"Status"} placeholder={"Select one.."} />
              </Flex>
            </Box>
          </Box>
          <Flex justifyContent={"flex-end"} gap={3}>
            <Button
              onClick={onClose}
              width={"174px"}
              height={"40px"}
              borderRadius={"12px"}
              bg={"none"}
              border={"1px solid #000000"}
              color={"#000000"}
              fontSize={"12px"}
              fontWeight={"500"}
              fontFamily={"PlusJakartaSansMedium"}
              letterSpacing={0.2}
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {}}
              width={"174px"}
              height={"40px"}
              borderRadius={"12px"}
              bg={"#000000"}
              color={"white"}
              fontSize={"12px"}
              fontFamily={"PlusJakartaSansMedium"}
              fontWeight={"500"}
              letterSpacing={0.2}
            >
              SAVE
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
